import { Alert } from '$tablet-app/src/app/models';
import { Goal } from '@akin-home/goals';
import produce from 'immer';
import { useCallback, useMemo, useReducer } from 'react';

interface State {
  goal?: Goal;
  periods_visible?: boolean;
  reminders_visible?: boolean;
}

type Action =
  | { type: 'SET_GOAL'; payload: { goal: Goal } }
  | { type: 'UPDATE_GOAL'; payload: Partial<Goal> }
  | { type: 'TOGGLE_SHOW_PERIODS' }
  | { type: 'TOGGLE_SHOW_REMINDERS' }
  | { type: 'ADD_REMINDER' }
  | { type: 'REMOVE_REMINDER'; payload: { index: number } }
  | { type: 'UPDATE_REMINDER'; payload: { index: number; reminder: Alert } };

const reducer = produce((state: State, action: Action) => {
  switch (action.type) {
    case 'SET_GOAL':
      state.goal = action.payload.goal;
      break;
    case 'UPDATE_GOAL':
      state.goal = { ...state.goal, ...action.payload } as Goal;
      break;
    case 'TOGGLE_SHOW_PERIODS':
      state.periods_visible = !state.periods_visible;
      break;
    case 'TOGGLE_SHOW_REMINDERS':
      state.reminders_visible = !state.reminders_visible;
      break;
    case 'ADD_REMINDER':
      state.reminders_visible = !state.reminders_visible;
      break;
    case 'UPDATE_REMINDER':
      state.reminders_visible = !state.reminders_visible;
      break;
    case 'REMOVE_REMINDER':
      state.reminders_visible = !state.reminders_visible;
      break;
  }
});

interface Params {
  goal?: Goal;
}

const useGoalFormScreen = (props?: Params) => {
  const [state, dispatch] = useReducer(reducer, { goal: props?.goal });

  const setGoal = useCallback(
    (goal: Goal) => dispatch({ type: 'SET_GOAL', payload: { goal } }),
    [dispatch]
  );

  const updateGoal = useCallback(
    (payload: Partial<Goal>) => dispatch({ type: 'UPDATE_GOAL', payload }),
    [dispatch]
  );

  const { toggleShowPeriods, toggleShowReminders } = useMemo(
    () => ({
      toggleShowPeriods: () => dispatch({ type: 'TOGGLE_SHOW_PERIODS' }),
      toggleShowReminders: () => dispatch({ type: 'TOGGLE_SHOW_REMINDERS' }),
    }),
    [dispatch]
  );

  return {
    state,
    setGoal,
    updateGoal,
    toggleShowPeriods,
    toggleShowReminders,
  };
};

export default useGoalFormScreen;
